// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "RoutingMetadataSidecarDto" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { RoutingMetadataStatus } from "./routing-metadata-status.enum.gen";
import { RoutingMetadataContentDtoGenShape } from "./routing-metadata-content-dto.gen";

export const RoutingMetadataSidecarDtoGenShape = z.strictObject({
  status: z.enum(RoutingMetadataStatus),
  taggingSkillVersionId: z.string(),
  taggingVersionName: z.string().optional(),
  content: RoutingMetadataContentDtoGenShape,
});
